const isArrayEmpty = (arr) => {
  return arr === undefined || arr.length == 0;
};
export { isArrayEmpty };
